import { render, staticRenderFns } from "./otherBanner.vue?vue&type=template&id=f64a95fe&scoped=true&"
import script from "./otherBanner.vue?vue&type=script&lang=js&"
export * from "./otherBanner.vue?vue&type=script&lang=js&"
import style0 from "./otherBanner.vue?vue&type=style&index=0&id=f64a95fe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64a95fe",
  null
  
)

export default component.exports